
<div class="row">
  <div class="col-sm-12">
    <h3 class="sub-title alert alert-info">Subscription Groups</h3>
  </div>
  <div class="col-sm-12 text-end alert">
       Add New Group
  </div>
</div>

<app-listing-group *ngIf="subscriptionGroupList"
 [subscriptionGroupList]="subscriptionGroupList"
 [server_user_id]="0"
></app-listing-group>



<app-spinner *ngIf="subscriptionGroupList && loading"></app-spinner>
<div *ngIf="subscriptionGroupList && !loading" class="text-center">No Records Found </div>


